export default __webpack_public_path__ + "static/media/GITNBLogo.078b1a21.png";